import { render, staticRenderFns } from "./BlockInstructions.vue?vue&type=template&id=ff6e211e&scoped=true&lang=pug&"
import script from "./BlockInstructions.vue?vue&type=script&lang=ts&"
export * from "./BlockInstructions.vue?vue&type=script&lang=ts&"
import style0 from "./BlockInstructions.vue?vue&type=style&index=0&id=ff6e211e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6e211e",
  null
  
)

export default component.exports